import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Paper, TextField } from 'components'
import { FaCheck } from 'react-icons/fa'

const defaultStyle = {
    backgroundColor: 'var(--primary-color)',
    textBorderColor: 'var(--seoncdary-color)',
    padding: '0',
    margin: '0',
    borderRadius: '5px',
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    overflow: hidden;
`

const ColorSection = styled.div`
    padding: 0.5rem;
    display: grid;
    grid-template-columns: 1.5rem 1.5rem 1.5rem 1.5rem 1.5rem;
    grid-template-rows: 1.5rem 1.5rem;
    column-gap: 0.5rem;
    row-gap: 0.5rem;
`

const Preview = styled.div`
    background-color: ${props => props.backgroundColor};
    width: 100%;
    height: 10vh;
    border-radius: 5px 5px 0 0;
`

const Block = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${props => props.color};
    border-radius: 5px;
    cursor: pointer;
    width: 1.5rem;
    height: 1.5rem;
    /* :hover {
        -webkit-box-shadow: ${props => `0px 0px 7px 1.5px ${props.color}`};
        -moz-box-shadow: ${props => `0px 0px 7px 1.5px ${props.color}`};
        box-shadow: ${props => `0px 0px 7px 1.5px ${props.color}`};
    }; */
`

const ColorPicker = props => {
    const {
        inline,
        color,
        colors,
        style,
        onChange,
        onClose,
        preview,
        customHex
    } = props;
    let updatedStyle = Object.assign({}, defaultStyle, style)
    const [hex, setHex] = useState(color || colors[0])
    
    

    let blocks = []
    colors.map(c => {
        if(c === color){
            blocks.push(<Block onClick={() => onSelectBlock(c)} color={c}><FaCheck style={{fontSize: '0.8rem', lineHeight: '0.8rem'}}/></Block>)
        } else {
            blocks.push(<Block onClick={() => onSelectBlock(c)} color={c}/>)
        }
        
    })

    const onHexInput = event => {
        setHex(event.target.value)
        if(event.target.value.match(/^#[a-f0-9]{6}$/i) !== null){
            onChange(event.target.value)
        }
    }

    const onSelectBlock = value => {
        onChange && onChange(value)
        setHex(value)
    }
    const content = 
    <Container style={updatedStyle}>
        {!inline | preview ? <Preview backgroundColor={color}/> : null}
        <ColorSection inline={inline}>
            {blocks}
        </ColorSection>
        {customHex ? <TextField value={hex.toUpperCase()} unfocus onChange={onHexInput} type='single' size='1' maxLength={7} style={{border: `1px solid ${updatedStyle.textBorderColor}`, padding: '0.5rem', margin: '0 0.5rem 0.5rem 0.5rem'}}/> : null}
    </Container>

    return (
        !inline ? <Paper>{content}</Paper> : <div>{content}</div>
    )
}

export default ColorPicker